export const formSubmit = (action: string, params: Record<string, string | undefined>) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    }
  });

  document.body.appendChild(form);
  return form.submit();
};
